import { apiClient } from "./apiClient";

export interface SavedFilterConfig {
  query?: string;
  state?: Record<string, unknown>;
  scope?: {
    legalEntityIds: string[];
    branchIds: string[];
  };
}

export interface SavedFilter {
  id: string;
  name: string;
  pageName: string;
  filterConfig: SavedFilterConfig;
  createdAt: string;
  updatedAt: string;
}

interface SavedFilterPayload {
  name: string;
  pageName: string;
  filterConfig: SavedFilterConfig;
}

export const savedFiltersService = {
  async list(pageName: string): Promise<SavedFilter[]> {
    const { data } = await apiClient.get<SavedFilter[]>("/saved-filters", { params: { pageName } });
    return data;
  },

  async create(payload: SavedFilterPayload): Promise<SavedFilter> {
    const { data } = await apiClient.post<SavedFilter>("/saved-filters", payload);
    return data;
  },

  async update(id: string, payload: SavedFilterPayload): Promise<SavedFilter> {
    const { data } = await apiClient.put<SavedFilter>(`/saved-filters/${id}`, payload);
    return data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/saved-filters/${id}`);
  },
};
